const LearnSkills = () => import('./views/LearnSkills');
const lessons = () => import('./views/Lessons');
const lesson = () => import('./views/Lesson');
const Surveys = () => import('./views/SurveysView')

const routes = [
  {
    path: '/learn-skills',
    name: 'LearnSkills',
    component: LearnSkills,
  },
  {
    path: '/activate-modules',
    name: 'activate-modules',
    component: () => import('./views/ActivateModules'),
  },
  {
    path: '/learn-skills/lessons/',
    component: () => import('./views/ModuleSkill'),
    children: [
      {
        name: 'lessons',
        path: ':id',
        component: lessons,
      },
      {
        name: 'lesson',
        path: ':id/lesson/:lesson',
        component: lesson,
      },
    ],
  },
  {
    path: '/manage-classes',
    name: 'manage-classes',
    component: () => import('./views/ManageClasses'),
  },
  {
    path: '/surveys',
    name: 'Surveys',
    component: Surveys,
  },
];

export default (router) => {
  routes.forEach((element) => {
    router.addRoute('main', element);
  });
};
